// ASDEA: vertical symbols
export {CONNETTORI_VERTICALI_INPUT_STRUCTURE, CONNETTORI_VERTICALI_OUTPUT_SCHEME} from './lib/asdea-vertical/consts';

// TIMBERTECH: wood symbols
export {CONNETTORI_LEGNO_INPUT_STRUCTURE, CONNETTORI_LEGNO_OUTPUT_SCHEME} from './lib/timbertech/consts';

// ASDEA: diaphragm symbols
export {CONNETTORI_INPUT_TYPES, CONNETTORI_OUTPUT_STRUCTURE} from './lib/asdea-diaphragm/consts';
export {CustomInputConnettoriGeometria} from './custom-input-geometria';
export {CustomInputConnettoriRinforzo} from './custom-input-rinforzo';
export {CustomInputConnettoriCarichi} from './custom-input-carichi';
import {FIELDS as FIELDS_GEOMETRIA} from './custom-input-geometria/lib/consts';
import {FIELDS as FIELDS_RINFORZO} from './custom-input-rinforzo/lib/consts';
import {FIELDS as FIELDS_CARICHI} from './custom-input-carichi/lib/consts';
export const FIELDS = {
  geometria: FIELDS_GEOMETRIA,
  rinforzo: FIELDS_RINFORZO,
  carichi: FIELDS_CARICHI,
}
export const FIELDS_LIST = {
  ...FIELDS_GEOMETRIA, ...FIELDS_RINFORZO, ...FIELDS_CARICHI
}
import {VALIDATE as VALIDATE_GEOMETRIA} from "./custom-input-geometria/lib/consts";
import {VALIDATE as VALIDATE_RINFORZO} from "./custom-input-rinforzo/lib/consts";
import {VALIDATE as VALIDATE_CARICHI} from "./custom-input-carichi/lib/consts";
export const VALIDATION = {
  geometria: VALIDATE_GEOMETRIA,
  rinforzo: VALIDATE_RINFORZO,
  carichi: VALIDATE_CARICHI,
}